export function getAvailableFrequenciesFromCalibrations(calibrations) {
  if (!Array.isArray(calibrations)) {
    return [];
  }

  return [
    ...new Set(
      calibrations
        .map((calibration) => calibration?.freq)
        .filter((freq) => freq != null),
    ),
  ].sort((a, b) => a - b);
}

export const PHONE_LISTENING_FREQUENCIES = [500, 1000, 2000, 4000, 8000, 16000];

export function getPhoneListeningFrequencies(calibrations) {
  return [
    ...new Set([
      ...getAvailableFrequenciesFromCalibrations(calibrations),
      ...PHONE_LISTENING_FREQUENCIES,
    ]),
  ].sort((a, b) => a - b);
}

export function buildRawListeningOwner(deviceCalibration) {
  return {
    ownerCalibrationId: deviceCalibration?.id ?? null,
    averagingLevel: null,
    brand: deviceCalibration?.brand || "",
    model: deviceCalibration?.model || "",
    deviceId: deviceCalibration?.deviceId || "",
    availableFrequencies: getPhoneListeningFrequencies(
      deviceCalibration?.calibrations,
    ),
  };
}

export function buildAveragedListeningOwner(averagedCalibration) {
  return {
    ownerCalibrationId: averagedCalibration?.id ?? null,
    averagingLevel: "BY_MODEL",
    brand: averagedCalibration?.brand || "",
    model: averagedCalibration?.model || "",
    deviceId: averagedCalibration?.deviceId || "",
    availableFrequencies: getPhoneListeningFrequencies(
      averagedCalibration?.calibrations,
    ),
  };
}

export function buildBluetoothSpeakerListeningOwner(calibration) {
  return {
    ownerCalibrationId: calibration?.id ?? null,
    averagingLevel: null,
    brand: "",
    model: calibration?.speakerModel || "",
    deviceId: calibration?.deviceId || "",
    availableFrequencies: getAvailableFrequenciesFromCalibrations(
      calibration?.calibrations,
    ),
  };
}
